import React from "react";
import Container from "../../../utils/Container";
import { useState } from "react";
import { Tooltip } from "@mui/joy";
import { FcApproval } from "react-icons/fc";
import { GoStarFill } from "react-icons/go";
import { CiLocationOn } from "react-icons/ci";
import {
  FaHeart,
  FaRegAddressCard,
  FaUmbrellaBeach,
  FaUsers,
} from "react-icons/fa";
import DhoorbinChoice from "../../../assets/icons/dhoorbinchoice.svg";
import { useParams } from "react-router";
import { useEffect } from "react";
import { getDetails } from "../../../api/website/tour/tourAPI";
import GuestChoice from "../../../assets/icons/guestchoice.svg";
import { FaLocationDot } from "react-icons/fa6";
import { IoTime } from "react-icons/io5";
import BookTour from "./components/BookTour";
import FloatingTourBooking from "./components/FloatingTourBooking";
import FloatingWhatsapp from "./components/FloatingWhatsapp";
import Lightbox from "yet-another-react-lightbox";

const SingleTour = () => {
  const { id } = useParams();
  const [TourData, setTourData] = useState("");
  const [OpenImageViewer, setOpenImageViewer] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetails(setTourData, id, setIsLoading);
  }, [id]);
  return (
    <>
      {IsLoading ? (
        <Container>
          <div className="py-4 lg:py-10 px-0 lg:px-10 space-y-10 animate-pulse">
            <div className="grid grid-col-1 lg:grid-cols-3 gap-3 border p-3 rounded-lg">
              <div className="col-span-0 lg:col-span-2 block lg:flex  gap-3">
                <div className="flex-1 h-[400px] bg-gray-200 rounded-md" />
                <div className="flex flex-row lg:flex-col gap-3 mt-3 lg:mt-0">
                  {[1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      className="w-[50px] lg:w-[70px] h-[50px] lg:h-[70px] bg-gray-200 rounded-md"
                    />
                  ))}
                </div>
              </div>

              <div className="space-y-5">
                <div className="h-6 w-3/4 bg-gray-200 rounded" />
                <div className="h-4 w-1/2 bg-gray-200 rounded" />
                <div className="h-4 w-full bg-gray-200 rounded" />
                <div className="h-4 w-full bg-gray-200 rounded" />
                <div className="h-10 w-1/2 bg-gray-200 rounded" />
              </div>
            </div>

            <div className="border p-3 rounded-lg grid grid-cols-2 lg:grid-cols-4 gap-3">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="flex gap-3 items-center p-4">
                  <div className="w-12 h-12 bg-gray-200 rounded-full" />
                  <div className="space-y-2 w-full">
                    <div className="h-3 w-1/2 bg-gray-200 rounded" />
                    <div className="h-5 w-3/4 bg-gray-200 rounded" />
                  </div>
                </div>
              ))}
            </div>

            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="border rounded-lg overflow-hidden">
                <div className="p-3 bg-gray-100">
                  <div className="h-4 w-1/3 bg-gray-200 rounded" />
                </div>
                <div className="p-4 space-y-2">
                  <div className="h-3 w-full bg-gray-200 rounded" />
                  <div className="h-3 w-full bg-gray-200 rounded" />
                  <div className="h-3 w-4/5 bg-gray-200 rounded" />
                </div>
              </div>
            ))}
          </div>
        </Container>
      ) : (
        <div>
          <FloatingWhatsapp />
          <FloatingTourBooking TourData={TourData} />
          <Container>
            {OpenImageViewer && (
              <>
                {TourData?.images && (
                  <Lightbox
                    open={OpenImageViewer}
                    close={() => setOpenImageViewer(false)}
                    styles={{
                      root: { "--yarl__color_backdrop": "rgba(0, 0, 0, .7)" },
                    }}
                    slides={TourData.images.map((img) => ({
                      src: img.imageLink,
                      alt: TourData.data.tourName,
                    }))}
                  />
                )}
              </>
            )}
            {TourData !== "" && (
              <>
                <div className="py-4 lg:py-10 px-0 lg:px-10 space-y-10 mb-10 lg:mb-0">
                  <div className="grid grid-col-1 lg:grid-cols-3 gap-3 border p-3 rounded-lg">
                    <div className="block lg:flex gap-3 col-span-0 lg:col-span-2 ">
                      <div className="flex-1">
                        <div
                          onClick={() => setOpenImageViewer(true)}
                          className="w-full h-[400px] overflow-hidden rounded-md border cursor-pointer"
                        >
                          <img
                            className="w-full h-full object-cover"
                            src={TourData?.images[0]?.imageLink}
                            alt={TourData.data.tourName}
                          />
                        </div>
                      </div>
                      <div className="pt-3 lg:pt-0 flex flex-row lg:flex-col gap-3">
                        {TourData?.images?.slice(1, 5).map((item, index) => {
                          return (
                            <div
                              onClick={() => setOpenImageViewer(true)}
                              key={index}
                              className="w-[50px] lg:w-[70px] h-[50px] lg:h-[70px] overflow-hidden rounded-md cursor-pointer"
                            >
                              <img
                                className="w-full h-full object-cover"
                                src={item?.imageLink}
                                alt={TourData.data?.tourName}
                              />
                            </div>
                          );
                        })}

                        {TourData?.images?.length > 5 && (
                          <div
                            onClick={() => setOpenImageViewer(true)}
                            className="w-[50px] lg:w-[70px] h-[50px] lg:h-[70px] overflow-hidden rounded-md relative cursor-pointer"
                          >
                            <img
                              className="w-full h-full object-cover"
                              src={TourData?.images[5]?.imageLink}
                              alt={TourData?.data.tourName}
                            />

                            <div className="absolute inset-0 bg-black/60 flex justify-center items-center">
                              <p className="text-xs lg:text-sm text-white font-semibold">
                                +{TourData.images.length - 5}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="space-y-8">
                      <div className="flex flex-col justify-start gap-x-1">
                        <div className="flex justify-start items-center gap-3">
                          <p className="py-2 font-bold text-md lg:text-xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                            {TourData.data.tourName}
                          </p>
                          {TourData.isFeatured && (
                            <div className="cursor-pointer">
                              <Tooltip
                                title="Dhoorbin Featured"
                                placement="top"
                                size="sm"
                              >
                                <FcApproval />
                              </Tooltip>
                            </div>
                          )}
                        </div>

                        <div className="flex justify-start items-center gap-x-3">
                          <div className="flex justify-start items-center gap-1">
                            <div>
                              <CiLocationOn />
                            </div>
                            <p className="text-xs text-black/50">
                              {TourData.data.city}, {TourData.data.country}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h3 className="text-sm text-black/80 font-bold">
                          Cancelation Policy
                        </h3>
                        <p className="text-sm text-black/50 text-justify">
                          {TourData.data.cancelationPolicy}
                        </p>
                      </div>
                      <div className="flex justify-start gap-3 items-center">
                        {TourData.data.isIdRequired && (
                          <div className="flex justify-star items-center gap-1 text-black/50">
                            <div>
                              <FaRegAddressCard />
                            </div>
                            <div>
                              <p className="text-xs text-black/50">
                                ID Required
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                      <div>
                        {TourData.data.isCoupleFriendly && (
                          <div className=" text-pink-500 bg-pink-200 border border-pink-500 px-2 py-0.5 rounded-sm cursor-pointer w-fit">
                            <Tooltip
                              title={
                                <div className="p-2">
                                  <p className="text-[10px]">
                                    No marrige certificate required
                                  </p>
                                  <p className="text-[10px]">
                                    Safety and comfort ensured
                                  </p>
                                  <p className="text-[10px]">
                                    Friendly Environment
                                  </p>
                                </div>
                              }
                              placement="right"
                              size="sm"
                            >
                              <div className="flex items-center justify-start gap-x-2">
                                <div className="text-xs">
                                  <FaHeart />
                                </div>
                                <p className="text-xs font-semibold">
                                  Couple Friendly
                                </p>
                              </div>
                            </Tooltip>
                          </div>
                        )}
                      </div>
                      {TourData.data.isDhoorbinChoice === 1 && (
                        <div>
                          <div className="flex items-start justify-start gap-2 border p-2 rounded-lg">
                            <div className="w-40 h-20">
                              <img
                                className="w-full h-full object-contain"
                                src={DhoorbinChoice}
                                alt=""
                              />
                            </div>
                            <div>
                              <p className="text-md font-bold ">
                                Dhoorbin Choice
                              </p>
                              <p className="text-xs text-justify text-black/70">
                                Dhoorbin Choice means this tour will be
                                supervised by Dhoorbin and marked safe and
                                enjoyable for travellers, we recommended.
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                      {TourData.data.isCustomerChoice === 1 && (
                        <div>
                          <div className="flex items-start justify-start gap-2 border p-2 rounded-lg">
                            <div className="w-40 h-16">
                              <img
                                className="w-full h-full object-contain"
                                src={GuestChoice}
                                alt=""
                              />
                            </div>
                            <div>
                              <p className="text-md font-bold ">Guest Choice</p>
                              <p className="text-xs text-justify text-black/70">
                                Guest Choice means this tour might be enjoyable
                                for travellers as per previous guest reviews.
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="border p-1 lg:p-3 rounded-lg grid grid-cols-2 lg:grid-cols-4 gap-3">
                    <div className="flex justify-start items-center gap-2 p-4">
                      <div>
                        <FaUmbrellaBeach className="text-2xl lg:text-4xl" />
                      </div>
                      <div>
                        <p className="text-xs text-black/70">Tour Start:</p>
                        <p className="text-sm lg:text-lg font-bold text-nowrap">
                          {new Date(TourData.data.startDate).toLocaleString(
                            "en-US",
                            {
                              month: "short",
                            },
                          )}{" "}
                          {new Date(TourData.data.startDate).getDate()} to{" "}
                          {new Date(TourData.data.endDate).toLocaleString(
                            "en-US",
                            {
                              month: "short",
                            },
                          )}{" "}
                          {new Date(TourData.data.endDate).getDate()}
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-start items-center gap-2">
                      <div>
                        <FaLocationDot className="text-2xl lg:text-4xl" />
                      </div>
                      <div>
                        <p className="text-xs text-black/70">Location:</p>
                        <p className="text-sm lg:text-lg font-bold">
                          {TourData.data.city}, {TourData.data.country}
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-start items-center gap-2 p-4">
                      <div>
                        <FaUsers className="text-2xl lg:text-4xl" />
                      </div>
                      <div>
                        <p className="text-xs text-black/70">Tour Size:</p>
                        <p className="text-sm lg:text-lg font-bold">
                          {TourData.data.minPeople} to{" "}
                          {TourData.data.maxiPeople} People
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-start items-center gap-2 p-4">
                      <div>
                        <IoTime className="text-2xl lg:text-4xl" />
                      </div>
                      <div>
                        <p className="text-xs text-black/70">Tour Duration:</p>
                        <p className="text-sm lg:text-lg font-bold">
                          {(new Date(TourData.data.endDate) -
                            new Date(TourData.data.startDate)) /
                            (1000 * 60 * 60 * 24)}{" "}
                          Days
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <div className="block lg:flex gap-3">
                      <div className="flex-1 w-full">
                        <div className="mb-5 overflow-hidden rounded-lg border">
                          <div className="border p-2 bg-gray-100">
                            <p className="text-md text-black font-bold">
                              Overview
                            </p>
                          </div>

                          <div className="p-2">
                            <p className="text-sm text-black/50">
                              {TourData.data.overview}
                            </p>
                          </div>
                        </div>
                        <div className="mb-5 overflow-hidden rounded-lg border">
                          <div className="border p-2 bg-gray-100">
                            <p className="text-md text-black font-bold">
                              Description
                            </p>
                          </div>

                          <div className="p-2">
                            <div
                              className="leading-7 text-sm"
                              dangerouslySetInnerHTML={{
                                __html: TourData.data.description,
                              }}
                            />
                          </div>
                        </div>
                        <div className="mb-5 overflow-hidden rounded-lg border">
                          <div className="border p-2 bg-gray-100">
                            <p className="text-md text-black font-bold">
                              Include and Exclude
                            </p>
                          </div>

                          <div className="p-2">
                            <div
                              className="leading-7 text-sm"
                              dangerouslySetInnerHTML={{
                                __html: TourData.data.includeOrexclude,
                              }}
                            />
                          </div>
                        </div>
                        <div className="mb-5 overflow-hidden rounded-lg border">
                          <div className="border p-2 bg-gray-100">
                            <p className="text-md text-black font-bold">
                              Addition Information
                            </p>
                          </div>

                          <div className="p-2">
                            <div
                              className="leading-7 text-sm"
                              dangerouslySetInnerHTML={{
                                __html: TourData.data.additionalInformation,
                              }}
                            />
                          </div>
                        </div>
                        <div className="mb-5 overflow-hidden rounded-lg border">
                          <div className="border p-2 bg-gray-100">
                            <p className="text-md text-black font-bold">
                              Travel Tips
                            </p>
                          </div>

                          <div className="p-2">
                            <div
                              className="leading-7 text-sm"
                              dangerouslySetInnerHTML={{
                                __html: TourData.data.travelTips,
                              }}
                            />
                          </div>
                        </div>
                        <div className="mb-5 overflow-hidden rounded-lg border">
                          <div className="border p-2 bg-gray-100">
                            <p className="text-md text-black font-bold">
                              Others
                            </p>
                          </div>

                          <div className="p-2">
                            <div
                              className="leading-7 text-sm"
                              dangerouslySetInnerHTML={{
                                __html: TourData.data.others,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="hidden lg:block w-full pt-5 lg:pt-0 lg:w-[300px] min-h-[300px] overflow-hidden rounded-lg ">
                        <BookTour TourData={TourData} />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Container>
        </div>
      )}
    </>
  );
};

export default SingleTour;
